import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { HashRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ApolloProvider } from '@apollo/client';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as TucarThemeProvider } from '@tucar/pit-stop';
import { Box } from '@mui/material';
import client from 'Contexts/graphql';
import AuthContext from 'Contexts/AuthContext';
import { AlertsContextProvider } from 'Contexts/AlertsContext';
import { AlertsContextProviderV2 } from 'Contexts/AlertsContextV2';
import tucar from 'Themes/Tucar';
import Router from './routes';
import 'Themes/fonts.css';

const history = createBrowserHistory();

const Content = () => (
  <AlertsContextProviderV2>
    <AlertsContextProvider>
      <Box sx={{ backgroundColor: 'primary.backgroundApp' }}>
        <AuthContext>
          <Router />
        </AuthContext>
      </Box>
    </AlertsContextProvider>
  </AlertsContextProviderV2>
);

const App = () => {
  const content = <Content />;
  return (
    <ApolloProvider client={client}>
      <StylesProvider injectFirst>
        <GoogleOAuthProvider clientId={process.env.GOOGLE_AUTH_ID}>
          <HashRouter history={history}>
            <TucarThemeProvider>
              <ThemeProvider theme={tucar}>{content}</ThemeProvider>
            </TucarThemeProvider>
          </HashRouter>
        </GoogleOAuthProvider>
      </StylesProvider>
    </ApolloProvider>
  );
};

export default App;
